import { Component, OnInit, ViewChild } from "@angular/core";
import { validateBasis } from "@angular/flex-layout";
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { BAAComponent } from "src/app/baa/baa.component";
import { CodeTable } from "src/app/core/model/v2/code-table";
import { HealthOrganizationData } from "src/app/core/model/v2/practice/HealthOrganizationData";
import { ResultBase } from "src/app/core/model/v2/practitioner/UserSetup";
import { CommonService } from "src/app/core/services/v2/common.service";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { TermsandConditionsComponent } from "src/app/termsand-conditions/termsand-conditions.component";

@Component({
  selector: "app-setup-organization",
  templateUrl: "./setup-organization.component.html",
  styleUrls: ["./setup-organization.component.scss"],
})
export class SetupOrganizationComponent implements OnInit {
  hoDto: HealthOrganizationData;
  activeTab: 1;
  form: FormGroup;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  constructor(
    private dialog: MatDialog,
    private commonService: CommonService,
    private practiceService: PracticeService,
    private router: Router,
    private loaderService: WindowLoaderService,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    let cuser = this.practiceService.getCurrentUser();
    
    this.activeTab = 1;
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ["", Validators.required],
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ["", Validators.required],
    });
    if (cuser != undefined && cuser.role == "Employer Agent") {
      this.router.navigate(["agency"]);
    }
    else {
      this.loaderService
        .blockWithLoader(this.practiceService.getHealthOrganizationData())
        .subscribe(
          (value) => {
            if (value.resultStatus.isSuccess) {
              this.updateLocalHoDto(value.result);

              this.form = new FormGroup({
                isAcceptedTermsConditions: new FormControl(
                  this.hoDto.isAcceptedTermsConditions,
                  Validators.requiredTrue
                ),
                isAcceptedBaa: new FormControl(
                  this.hoDto.isAcceptedBaa,
                  Validators.requiredTrue
                ),
                isCertify: new FormControl(
                  this.hoDto.isCertify,
                  Validators.requiredTrue
                ),
              });
            }
          },
          (error) => { },
          () => { }
        );
    }
    // this.hoDto = new HealthOrganizationData();
  
  }

  private updateLocalHoDto(value: HealthOrganizationData) {
    this.hoDto = value;
    if (
      this.hoDto.isAcceptedBaa &&
      this.hoDto.isAcceptedTermsConditions &&
      this.hoDto.isCertify
    ) {
      this.router.navigate(["/physician/profile/setup"]);
    }
  }

  openbaaDialog() {
    const dialogRef = this.dialog.open(BAAComponent);
    dialogRef.afterClosed().subscribe(
      (rest) => {
        this.form.controls["isAcceptedBaa"].setValue(rest);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  openDialog() {
    const dialogRef = this.dialog.open(TermsandConditionsComponent);
    dialogRef.afterClosed().subscribe(
      (rest) => {
        this.form.controls["isAcceptedTermsConditions"].setValue(rest);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  goToSetupPractice() {
    this.hoDto = this.form.value;
    this.loaderService
      .blockWithLoader(
        this.practiceService.updateHealthOrganizationData(this.hoDto)
      )
      .subscribe((value) => {
        if (value.resultStatus.isSuccess) {
          this.updateLocalHoDto(value.result);
        }
      });
    // this.router.navigate(['/physician/profile/setupCheckout']);
  }

  Next(tab) {
    this.activeTab = tab;
  }
  Back(tab) {
    this.activeTab = tab;
  }
  Finish() {
    console.log("Tab Finish ");
  }
}
